import * as React from 'react'
import { motion } from 'motion/react'

import cn from '@config/tailwind/cn'

import type { CardAction } from './card-action'

export type BookCoverCardSize = 'large' | 'small'

/** Shared dimensions for BookCoverCard and cards that mirror its cover sizing (e.g. ContinueReadingCard). */
export const bookCoverCardSizeStyles: Record<
  BookCoverCardSize,
  { wrapper: string; img: { width: number; height: number } }
> = {
  large: { wrapper: 'srd:w-[156px] srd:h-[208px]', img: { width: 156, height: 208 } },
  small: { wrapper: 'srd:w-[120px] srd:h-[160px]', img: { width: 120, height: 160 } },
}

interface BookCoverCardProps {
  id?: string
  coverUrl: string
  action?: CardAction
  size?: BookCoverCardSize
  className?: string
}

export function BookCoverCard({ id, coverUrl, action, size = 'large', className }: BookCoverCardProps) {
  const { wrapper, img } = bookCoverCardSizeStyles[size]
  const interactiveProps = action ? { whileHover: { scale: 1.025 }, whileTap: { scale: 0.975 } } : {}

  const content = (
    <motion.div data-id={id} {...interactiveProps} className={cn(action && 'srd:cursor-pointer', wrapper, className)}>
      <div className='srd:rounded-2xl srd:overflow-hidden srd:w-full srd:h-full'>
        <img
          src={coverUrl}
          alt=''
          width={img.width}
          height={img.height}
          draggable={false}
          loading='lazy'
          decoding='async'
          className='srd:w-full srd:h-full srd:object-cover'
        />
      </div>
    </motion.div>
  )

  if (!action) return content
  if (action.type === 'link') return action.renderWrapper(content)
  return (
    <button type='button' onClick={action.onClick} className='srd:block'>
      {content}
    </button>
  )
}
